import { render, staticRenderFns } from "./Supplies.vue?vue&type=template&id=3f327932&"
import script from "./Supplies.vue?vue&type=script&lang=ts&"
export * from "./Supplies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports